export const updateFavicon = (tenantName: string) => {
    if(!tenantName) return;

    const faviconPath = `/${tenantName.toLowerCase()}-favicon.ico`;
    // Remove all existing favicon links
    const existingLinks = document.querySelectorAll("link[rel*='icon']");
    existingLinks.forEach(link => link.remove());
    
    // Create new favicon link with cache busting
    const newFavicon = document.createElement('link');
    newFavicon.rel = 'icon';
    newFavicon.type = 'image/x-icon';
    newFavicon.href = `${faviconPath}?v=${Date.now()}`; // Cache busting
    document.head.appendChild(newFavicon);
    
    // Also add shortcut icon
    const shortcutIcon = document.createElement('link');
    shortcutIcon.rel = 'shortcut icon';
    shortcutIcon.type = 'image/x-icon';
    shortcutIcon.href = `${faviconPath}?v=${Date.now()}`;
    document.head.appendChild(shortcutIcon);
    // // Update existing favicon
    // let favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement;
    
    // if (!favicon) {
    //     // Create if doesn't exist
    //     favicon = document.createElement('link');
    //     favicon.rel = 'icon';
    //     document.head.appendChild(favicon);
    // }
    
    // favicon.href = faviconPath;
    
    // // Also update apple-touch-icon if you have them
    // const appleTouchIcon = document.querySelector("link[rel='apple-touch-icon']") as HTMLLinkElement;
    // if (appleTouchIcon) {
    //     appleTouchIcon.href = `/favicons/${tenantName.toLowerCase()}-apple-touch-icon.png`;
    // }
};
